import { CONTENT_WRP_ID } from '@framework/ui/Templates/ContentWrp/constants';

export const getDialInCountriesTableSelectLayoutProps = (isEvercallLanding: boolean) => (
  {
    isUsePortal: true,
    scrollableParentElements: [isEvercallLanding ? window : document.getElementById(CONTENT_WRP_ID)],
    ...(isEvercallLanding && {
      getMenuOuterStyle: (defaultGetMenuOuterStyle, selectContainerEl) => (
        {
          ...defaultGetMenuOuterStyle(),
          top: selectContainerEl.getBoundingClientRect().top,
          zIndex: 2,
        }
      ),
    }),
  }
);
